<template xmlns="http://www.w3.org/1999/html">
  <!--首页-->
  <div class="page-container"> <!-- 新增外层容器统一控制 -->
    <headers></headers>
    <carousel></carousel>

    <div class="auto padding250">
<!--      <div class="item">    &lt;!&ndash; 勤博动态 &ndash;&gt;-->
<!--        <div class="title">-->
<!--          <p>勤博动态</p>-->
<!--          <p>Chamberlain news</p>-->
<!--        </div>-->
<!--        <ul class="new_ul font14">-->
<!--          <li v-for="news in newses" @click.prevent.stop="detailNews(news.id)">-->
<!--            <p>{{news.messageTitle}}</p>-->
<!--            <span class="pull-right" v-if="news.updateTime">{{news.updateTime | timeFilter}}</span>-->
<!--            <span class="pull-right" v-else>{{news.createTime | timeFilter}}</span>-->
<!--          </li>-->
<!--          <Button size='large' class="lookmore" @click="moreNewses" style="margin-top: 25px">查看更多<Icon type="ios-arrow-forward"></Icon></Button>-->
<!--        </ul>-->
<!--      </div>-->

 <!-- 产品与服务 -->
  <div class="title">
    <p>产品与服务</p>
    <p>Products and Services</p>
  </div>
  <ul class="product_list">
    <li v-for="(course,index) in product" @click="detailProduct(course.moduleType)">
      <div class="curse">
        <img :src="course.sliderImg" alt="产品图片">
        <span>{{course.courseBeginDate}}</span>
      </div>
    </li>
  </ul>

<!--      <Button size='large' class="lookmore" @click="moreNewses" style="margin-top: 25px">查看更多<Icon type="ios-arrow-forward"></Icon></Button>-->

<!--      <div class="item">  &lt;!&ndash; 品牌数据 &ndash;&gt;-->
<!--        <div class="title">-->
<!--          <p>品牌数据</p>-->
<!--          <p>Brand data</p>-->
<!--        </div>-->
<!--        <ul class="brand_list">-->
<!--          <li @click="detail(index)">-->
<!--            <div class="curse">-->
<!--              <img :src="brandImg" alt="品牌数据" class="brand-img">-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul></div>-->


      <!-- 合作伙伴 -->
<!--      <div class="title">-->
<!--        <p>合作伙伴</p>-->
<!--        <p>Partner</p>-->
<!--      </div>-->
<!--      <ul class="partner_list">-->
<!--        <li @click="detail(index)">-->
<!--          <div class="curse">-->
<!--            <img :src="partnersImg" alt="合作伙伴" class="partner-img">-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
<!--      <Button size='large' class="lookmore" @click="moreNewses" style="margin-top: 25px">查看更多<Icon type="ios-arrow-forward"></Icon></Button>-->
    </div>




    <!-- 弹窗组件 -->
    <Modal v-model="modal" class-name="vertical-center-modal" footer-hide>
      <p slot="header" class="header">查询结果</p>
      <p class="resultNo"><span>无该证书相关信息，请检查证书编号</span></p>
    </Modal>
    <Modal v-model="modal1" class-name="vertical-center-modal" footer-hide>
      <p slot="header" class="header">查询结果</p>
      <div v-html="content" class="xieyi"></div>
    </Modal>

    <!-- 加载中 -->
    <Spin fix v-show="isSpinShow" >
      <div class="loader">
        <Icon type="ios-loading" size=26 class="demo-spin-icon-load"></Icon>
        <div class="font14">加载中...</div>
      </div>
    </Spin>

    <asides></asides>
    <footers></footers>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
// 全局基础配置
html {
  font-size: 16px; // 基准rem（1rem=16px）
  @media (max-width: 750px) {
    font-size: 14px; // 手机端缩小基准
  }
  @media (min-width: 1920px) {
    font-size: 18px; // 大屏放大基准
  }
}
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
*, *::before, *::after {
  box-sizing: inherit; // 统一盒模型
}
.page-container {
  width: 100%;
  max-width: 1920px; // 大屏最大宽度限制
  margin:  auto; // 居中
 // padding: 0 2vw; // 左右留白随视口变化
}

// 旋转加载动画
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from { transform: rotate(0deg);}
  50% { transform: rotate(180deg);}
  to { transform: rotate(360deg);}
}
.ivu-spin-fix {
  position: fixed;
  z-index: 9999;
}

// 弹窗样式
.xieyi {
  padding: 20px;
  line-height: 25px;
  text-align: left;
  font-size: 0.875rem; // 14px
}
.header {
  text-align: center;
  font-size: 1.25rem; // 20px
  @media (max-width: 750px) {
    font-size: 1rem; // 16px
  }
}
.resultNo {
  text-align: center;
  font-size: 0.9375rem; // 15px
  @media (max-width: 750px) {
    font-size: 0.875rem; // 14px
  }
}

// 主体内容
.auto {
  width: 95%;
 // display: flex; // 替换float为flex
 // flex-wrap: nowrap;
//  flex-direction:row ; /* 横向排列 */
//.item{
//  flex: 0 1 calc(33.333% - 1vw);
//}
  // 标题样式
  .title {
    text-align: center;
    margin: 5vh 0 2vh; // 用视口高度替代固定px，适配不同屏幕
    p:first-child {
      font-size: 1.625rem; // 26px
      color: #000;
      @media (max-width: 750px) {
        font-size: 1.25rem; // 20px
      }
      @media (min-width: 1920px) {
        font-size: 1.875rem; // 30px
      }
    }
    p:last-child {
      font-size: 0.875rem; // 14px
      color: #999;
      @media (max-width: 750px) {
        font-size: 0.75rem; // 12px
      }
    }
  }

  // 勤博动态列表
  .new_ul {
    // 添加卡片样式
    background-color: #fff; // 背景色
    border-radius: 20px; // 圆角
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); // 阴影
    border: 1px solid #f0f0f0; // 边框
    list-style: none;
  //  padding: 2vw;
    margin: 0 auto;
    display: flex; // 替换float为flex
    flex-wrap: nowrap;
   // gap: 1vw; // 间距随视口变化
    flex-direction: column;
    li {
     // flex: 1 1 calc(50% - 1vw); // 自适应宽度，最小占比

     // min-width: 180px; // 手机端最小宽度
      line-height: 2.5rem; // 40px
      text-align: left;
      cursor: pointer;
      padding-left: 15px;
      position: relative;
      font-size: 0.875rem; // 14px
      // 使用 flex 实现一行垂直居中
      display: flex;
      align-items: center; // 垂直居中
      // 添加分割线效果（可选）
      border-bottom: 1px solid #f0f0f0;
      p {
      //  width:300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 0 1vw 0  0;
        padding: 0;
      }
      span {
        color: #999;
        font-size: 0.75rem; // 12px
      }
      &::before {
        width: 5px;
        height: 5px;
        background-color: #000;
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &:hover {
        color: #9C7649;
      //  border-bottom: 1px solid #9C7649;
      }
    }
  }

  // 查看更多按钮
  .lookmore {
    font-size: 0.875rem; // 14px
    color: #666;
    background-color: #f5f5f5;
    border-color: #ddd;
    height: 2.5rem; // 40px
    width: 8.75rem; // 140px
    border-radius: 4px;
    display: block;
    margin: 0 auto; // 按钮居中
    .ivu-icon {
      margin-bottom: 2px;
      color: #999;
    }
    @media (max-width: 750px) {
      width: 100%;
      max-width: 140px;
    }
  }

  // 产品与服务列表
  .product_list {

    padding:  0;
    margin:  auto 5vw;
    list-style: none;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    flex-direction: row;
    gap: 1vw; // 间距自适应

    li {
      flex: 1 ; // 自适应宽度，最小220px
     // 大屏最大宽度
      background-color: #fff;
      cursor: pointer;
      transition: all 0.3s;
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      flex-direction: column;
      padding: 0 ;
      &:hover {
        transform: translateY(-10px);
        border-color: #957960;
      }

      .curse {
        width: 100%;
        height: 100%;
        position: relative;
        padding: 0 5px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;

        flex-direction: column;
        img {
         // width: 100px; // 宽度自适应父容器
          max-width: 100%;
         // flex: 1;
          height: 100%; // 高度等比例缩放
          aspect-ratio: 613/740; // 固定宽高比（原220:340）
          object-fit: cover;
       //   border-radius: 18px;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          transform: translateZ(0);
          filter: blur(0.3px);
          box-shadow: inset 0 0 14px rgba(255,255,255,0.2);
        }
      }
    }
  }

  // 品牌数据
  .brand_list {

    padding: 2vh 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: center;
    width: 100%;

    li {
      width: 100%;
      max-width: 1920px; // 大屏最大宽度
      background-color: #fff;

      .curse {
        width: 100%;
        .brand-img {
          width: 100%;
          height: auto;
          aspect-ratio: 1200/580; // 固定原比例
          object-fit: cover;
        }
      }
      &:hover {
        transform: translateY(-10px);
        border-color: #957960;
        transition: all 0.3s;
        cursor: pointer;
      }
    }
  }

  // 合作伙伴
  .partner_list {
   // padding: 20vh 0;

    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1vw;

    li {
      flex: 1; // 自适应占比
      min-width: 80px; // 手机端最小宽度
      max-width: 100%; // 大屏最大宽度
      background-color: #fff;
      margin: 2px;

      .curse {
        position: relative;
        .partner-img {
          width: 100%;
          height: auto;
         // aspect-ratio: 1200/580; // 固定原比例
        //  aspect-ratio: 1/1; // 圆形图片固定1:1比例
          object-fit: cover;

        }
      }
      &:hover {
        transform: translateY(-10px);
        border-color: #957960;
        transition: all 0.3s;
        cursor: pointer;
      }
    }
  }
}

// 证书查询模块（若启用）
.index_search {
  background-color: #fff;
  box-shadow: 0 3px 7px rgba(204,204,204,0.3);
  padding: 2vh 0;
  width: 100%;

  .clearfix {
    margin: 0 auto;
    width: 90%;
    max-width: 1000px; // 大屏最大宽度
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1vw;
  }
  .label {
    color: #000;
    font-size: 1.25rem; // 20px
    @media (max-width: 750px) {
      width: 100%;
      margin-bottom: 10px;
    }
  }
  .searchOut {
    flex: 1 1 80%;
    min-width: 280px;
    height: 2rem; // 32px
    display: flex;
    border: 1px solid #957960;
    border-radius: 3px;

    .ivu-input {
      flex: 1;
      border: 1px solid #957960;
      height: 2rem;
      line-height: 2rem;
      font-size: 0.875rem;
      color: #333;
      padding: 0 15px 0 5px;
    }
    .searchBtn {
      white-space: nowrap;
      padding: 0 15px;
      background-color: #957960;
      color: #fff;
      font-size: 0.875rem;
      line-height: 2rem;
      cursor: pointer;
      &:active {
        background-color: darken(#957960,3%);
      }
    }
  }
}

// 证书弹窗样式（若启用）
.row-con {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 20px auto;
  justify-content: space-around;
  gap: 2vw;
  ul {
    border-bottom: 1px dashed #DBDBDB;
    margin-bottom: 5px;
    padding: 0;
  }
  li {
    color: #666;
    list-style: none;
    font-size: 0.875rem;
  }
  span {
    color: #000;
  }
  .el-card {
    width: 100%;
    max-width: 350px;
    margin-bottom: 20px;
  }
}

// 媒体查询：手机端特殊适配
@media (max-width: 750px) {
  .auto {
    padding: 0 4vw;

    .new_ul li {
      flex: 1 1 100%; // 手机端一行一个
      min-width: 100%;
    }

    .product_list li {
      flex: 1 1 45%; // 手机端一行两个
    }

    .partner_list li {
      flex: 1 1 20%; // 手机端一行5个
    }

    .title {
      margin: 5vh 0 1.5vh;
    }
  }

  // 弹窗适配手机
  .vertical-center-modal {
    width: 90% !important;
    height: 80% !important;
    margin: 0 auto;
  }
}

// 大屏适配（1920px以上）
@media (min-width: 1920px) {
  .auto {
    max-width: 1920px;
    margin: 0 auto;

    .title {
      margin: 10vh 0 3vh;
    }
  }
}
</style>
<script type="text/ecmascript-6">
  import classes from '../template/live'
  import course from '../template/course'
  import asides from '../template/aside'
  import headers from '../template/header'
  import footers from '../template/footer'
  import carousel from '../template/carousel'
  import {indexWeb, indexLecturers, centreInfoWeb, searchByNum, downCertifite, slidersWebIndex,sliderPC} from "../../http"
  import {getStore,setStore} from "../../storage";
  import {timeFilter} from "../../myFilters"
  export default {
        name: 'index',
        props: {},
        data() {
            return {
              certificateList:[],
              certificateNum: '',//证书编号
              cerRemark:'',
              cerSearchShow:false,
              content: '',
              modal: false,
              modal1: false,
              isSpinShow:false,                     //加载框
              loginshow1:false,
              offcourses:[],                        //线下课列表
              lecturers : [],                       //推荐讲师列表
              lives : [],                           //直播列表
              courses : [],                        //推荐课程列表
              newses:[],                            //新闻列表
              pageNumber:1,
              online:1,                             //是否线上课程
              isVip:0,                              //是否是Vip
              product:[]   ,                        //产品与服务
              brandImg:''  ,                         //品牌数据
              partnersImg:''  ,                         //合作伙伴
            };
        },
        methods: {
          //关闭dialog
          dialogClose(){
            this.certificateNum='';
            this.certificateList=[];
          },
          //新闻详情
          detailNews(newsId){
            this.$router.push({
              name:'newsdetail',
              query:{
                newsId:newsId,
              }
            })
          },
          //更多新闻
          moreNewses(){
            this.$router.push({
              name:'news'
            })
          },
          //查看更多直播
          moreLives(){
              this.$router.push({
                  name:'zhibolist',
                  query:{ pageNumber: 1 },
              })
          },
          //查看更多推荐课程
          moreCourses(){
              this.$router.push({
                  name:'courselist',
                  query:{
                    coursetype: 0,
                    coursetypeId:'',
                  }
              })
          },
          //查看更多线下课程
          moreOffcourses(){
              this.$router.push({
                  name:'offcourselist',
              })
          },
          //查看更多推荐讲师
          moreLecturer(){
            this.$router.push({
              name:'lecRecomlist'
            })
          },
          //查看推荐讲师课程
          lecturerList(id){
              this.$router.push({
                  name:'lecturerlist',
                  query:{'lecturerId' : id},
              })
          },
          //线下课程详情
          detail(index){
            let offcourse = this.offcourses[index];
            this.$router.push({
              name:'offcoursedetail',
              query:{courseId:offcourse.id}
            })
          },

          detailProduct(e){
            this.$router.push({
              name:e
            })
          },
          //获取页面数据
          getIndex(){
            //获取首页数据
            if(this.isSpinShow === false) {
              this.isSpinShow = true;
              centreInfoWeb().then(res => {
                if (res.code !== 200) {
                }
                indexWeb({pageNumber:1,pageSize:10}).then(res => {
                  this.isSpinShow = false;
                  this.offcourses = res.data.offcourses;
                  this.lives = res.data.lives;
                  this.courses = this.getOncourses(res.data.courses);
                  this.newses = res.data.newses;
                  this.isVip = res.data.isVip;
                }).catch();
                //获取推荐导师
                //随机查询4个导师，pageSize为4
                indexLecturers({pageNumber: 1,pageSize:4}).then(res => {
                  //从走马灯改为标签不在使用
                  /*let list = res.data.lecturers.rows;
                  //讲师列表拆分
                  let arr = list; //要拆分的数组
                  let len = 4;  //每组元素个数
                  let a_len = arr.length;
                  let result = [];  //结果数组
                  for (let i = 0; i < a_len; i += len) {
                    let res = arr.slice(i, i + len);
                    result.push(res);
                  }
                  this.lecturers = result;*/
                  this.lecturers = res.data.lecturers.rows;
                }).catch();
              }).catch(() =>{
                this.isSpinShow = false;
              })
            }
          },
          getProduct(){
            slidersWebIndex({sliderType:13}).then(res => {
                  this.product = res.data.sliders;
                  this.widths= -this.$refs.pages.offsetWidth / 2;
                  // this.heights=this.$refs.slideImg[0].offsetHeight
                });
            sliderPC({sliderType:14}).then(res => {
                  this.brandImg = res.data.slider.sliderImg;
                  this.widths= -this.$refs.pages.offsetWidth / 2;
                  // this.heights=this.$refs.slideImg[0].offsetHeight
                });
            sliderPC({sliderType:15}).then(res => {
                  this.partnersImg = res.data.slider.sliderImg;
                  this.widths= -this.$refs.pages.offsetWidth / 2;
                  // this.heights=this.$refs.slideImg[0].offsetHeight
                });
          },
          //线上课程首页只显示前8个
          getOncourses(course){
            let num = 8;        //目前只显示8个课程
            let newArr = new Array();
            if(course.length !== undefined) {
              for (let i = 0; i < course.length && i < num; i++) {
                newArr.push(course[i]);
              }
            }
            return newArr;
          },
          searchCertificate(){
            let that = this
            this.isSpinShow = true;
            if(this.certificateNum == ''){
              this.isSpinShow = false;
              this.$Notice.warning({
                title: '证书查询提醒',
                desc: '请输入身份证号查询'
              });
              return;
            }
            centreInfoWeb().then(res => {
              if (res.code !== 200) {
                this.isSpinShow = false;
                that.$Notice.warning({
                  title: '证书查询提醒',
                  desc: '您还未登录，请登录'
                });
                return;
              }
              searchByNum({certificateNum : that.certificateNum}).then(res => {
                console.info(res)
                that.isSpinShow = false;
                that.cerSearchShow = true;
                if(res.data){
                  console.log("证书结果",res.data)
                  if (res.data.length===0){
                    //没有证书
                    that.cerRemark="对不起，您未完成规定的课时学习，请您确认学习进度，尽快完成学习任务。"
                  }else{
                    that.cerRemark="恭喜您参加物业管理师四（三、二、一）级培训，获取结业证书证！"
                    that.certificateList = res.data;
                  }
                  // downCertifite({userCertifiId: res.data.id, userId: res.data.userId}).then(res => {
                  //   console.info(res)
                  //   that.content = res.replace("../", "http://www.cbstudy.com/base/")
                  //   that.modal1 = true
                  //   that.modal = false
                  // })
                }else{
                  that.modal = true
                  that.modal1 = false
                  return;
                }
              });
            })
          },

          downloadCer(url,name,idCard){
            let replaceUrl = url.replace('http','https');
            const link = document.createElement('a');
            // 这里是将链接地址url转成blob地址，
            fetch(replaceUrl).then(res => res.blob()).then(blob => {
              link.href = URL.createObjectURL(blob)
              // 下载文件的名称及文件类型后缀
            //  link.download =name+parseInt(new Date().getTime() / 1000) + ''+".pdf";
              link.download =name+idCard+".pdf";

              document.body.appendChild(link)
              link.click()
              //在资源下载完成后 清除 占用的缓存资源
              window.URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
            });


          }
        },
        created() {
          this.getIndex();
          this.getProduct();
        },
        components: {

          asides,
          headers,
          footers,
          course,
          carousel,
          classes,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/index/index.vue